import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';

import featureImg from './img/feature-img.avif';
import css from './CreatorsPage.module.css';

const SectionFeature = () => {
  return (
    <div className={css.sectionFeature}>
      <img className={css.featureImg} alt="Performing" src={featureImg} />
      <div className={css.featureContent}>
        <h2 className={css.featureTitle}>
          <FormattedMessage id="CreatorsPage.featureTitle" />
        </h2>
        <p className={css.featureText}>
          <FormattedMessage
            id="CreatorsPage.featureText"
            values={{
              textBreak: <br />,
            }}
          />
        </p>
      </div>
    </div>
  );
};

export default SectionFeature;
